export class UserLoginData {

    isAdmin: boolean = false;
    isSuperAdmin: boolean = false;
    groups: string[] = [];
    groupsDescription: string[] = [];
    companyId!: string;
    companyName!: string;
    fullName!: string;
    username!: string;

}